import React from "react";
import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { pipe } from "fp-ts/function";
import * as Option from "fp-ts/Option";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { showData, _ShortsData, _IsSeasonsAvailable } from "./optics";
const ShowTabsView = React.lazy(() => import("./view"));
const getProps = (data) => {
    const showDetails = Fold.toArray(showData, data);
    const isSeasonsAvailable = Fold.preview(_IsSeasonsAvailable, data);
    const shortData = Fold.toArray(_ShortsData, data);
    return {
        showDetails,
        shortData,
        isSeasonsAvailable,
    };
};
const Tabs = ({ showDetails, shortData, environment, isSeasonsAvailable, }) => {
    const webAuthUrl = environment.authService.protocol + "://" + environment.authService.domain;
    const isSeasonDataAvailableM = pipe(isSeasonsAvailable, Option.getOrElse(() => []));
    const isSeasonDataAvailable = isSeasonDataAvailableM.length > 1;
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(ShowTabsView, { read: environment, showDetails: showDetails, shortData: shortData, webAuthRedirectionUrl: webAuthUrl, isSeasonDataAvailable: isSeasonDataAvailable })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, Tabs);

